/**
 * 语音模块统一错误。
 *
 * 1000~1006 是录音/浏览器能力这一层的错误，2xxx 是厂商与凭证这一层的错误。
 * 与 wohui-web-v2 的 src/speech/errors.js 保持一致，两个项目共用同一套编号。
 */
export const SpeechErrorCode = {
  /** 厂商/网络请求失败 */
  NETWORK: '1000',
  /** 拿不到可用的凭证或接入点 */
  NO_ENDPOINT: '1001',
  /** 浏览器缺少所需 API（fetch / FormData 等） */
  UNSUPPORTED: '1002',
  /** 浏览器不支持 Web Audio */
  NO_WEB_AUDIO: '1003',
  /** 请求麦克风失败（被拒绝 / 无设备） */
  MIC_DENIED: '1004',
  /** 超时 */
  TIMEOUT: '1005',
  /** getUserMedia 不可用（多为非安全上下文） */
  NO_GET_USER_MEDIA: '1006',
  /** 凭证接口返回失败 */
  CREDENTIAL_FAILED: '2001',
  /** 厂商拒绝凭证（401/403），调用方应刷新凭证后重试一次 */
  VENDOR_REJECTED: '2002',
  /** 厂商返回其它错误 */
  VENDOR_FAILED: '2003',
  /** 厂商返回体无法解析出分数/文本 */
  BAD_RESPONSE: '2004',
  /** 录音为空（时长过短） */
  EMPTY_AUDIO: '2005',
  UNKNOWN: '9999',
}

export class SpeechError extends Error {
  /**
   * @param {string} code SpeechErrorCode 之一
   * @param {string} message 人读信息（可含厂商原文）
   * @param {object} [extra] 附加信息：vendor / status / body / requestId 等，只用于日志与上报
   */
  constructor(code, message, extra) {
    super(message || code)
    this.name = 'SpeechError'
    this.code = code || SpeechErrorCode.UNKNOWN
    if (extra) Object.assign(this, extra)
  }

  /** 是否应刷新凭证后重试 */
  get shouldRefreshCredential() {
    return this.code === SpeechErrorCode.VENDOR_REJECTED
  }
}

/** 把任意异常收敛为 SpeechError */
export function toSpeechError(e, fallbackCode = SpeechErrorCode.UNKNOWN, extra) {
  if (e instanceof SpeechError) return e
  if (e && e.name === 'AbortError') {
    return new SpeechError(SpeechErrorCode.TIMEOUT, 'request timeout', extra)
  }
  const message = (e && (e.message || e.errmsg || e.msg)) || String(e)
  return new SpeechError(fallbackCode, message, extra)
}
